// extracted by mini-css-extract-plugin
export default {"container":"o4-z","heading":"p4-z","links":"q4-z","copy":"r4-z","subCopy":"s4-z","linksLeft":"t4-z","linksCenter":"u4-z","linksRight":"v4-z","link":"w4-z","onlyLink":"x4-z"};